import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotepad = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.75 3.75H5.95C4.8299 3.75 4.26984 3.75 3.84202 3.96799C3.46569 4.15973 3.15973 4.46569 2.96799 4.84202C2.75 5.26984 2.75 5.82989 2.75 6.95V15.05C2.75 16.1701 2.75 16.7302 2.96799 17.158C3.15973 17.5343 3.46569 17.8403 3.84202 18.032C4.26984 18.25 4.8299 18.25 5.95 18.25H14.05C15.1701 18.25 15.7302 18.25 16.158 18.032C16.5343 17.8403 16.8403 17.5343 17.032 17.158C17.25 16.7302 17.25 16.1701 17.25 15.05V6.95C17.25 5.82989 17.25 5.26984 17.032 4.84202C16.8403 4.46569 16.5343 4.15973 16.158 3.96799C15.7302 3.75 15.1701 3.75 14.05 3.75H13.25M8.35 5.75H11.65C12.2101 5.75 12.4901 5.75 12.704 5.64101C12.8922 5.54513 13.0451 5.39215 13.141 5.20399C13.25 4.99008 13.25 4.71005 13.25 4.15V3.35C13.25 2.78995 13.25 2.50992 13.141 2.29601C13.0451 2.10785 12.8922 1.95487 12.704 1.85899C12.4901 1.75 12.2101 1.75 11.65 1.75H8.35C7.78995 1.75 7.50992 1.75 7.29601 1.85899C7.10785 1.95487 6.95487 2.10785 6.85899 2.29601C6.75 2.50992 6.75 2.78995 6.75 3.35V4.15C6.75 4.71005 6.75 4.99008 6.85899 5.20399C6.95487 5.39215 7.10785 5.54513 7.29601 5.64101C7.50992 5.75 7.78995 5.75 8.35 5.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgNotepad);
export { ForwardRef as ReactComponent };
